import React, { useState } from 'react'
import signin from '../../services/signin'
import './ResetBaseButton.scss'

const ResetBaseButton = () => {
  const [displayText, setDisplayText] = useState('Resetar base (CPF)')

  const handleResetBase = () => {
    try {
      setDisplayText('Carregando')

      return signin(null, false).then(({ http }) => {
        const payload = {
          event: 'reset_cpf',
          data: null,
        }

        return http.post(`reset_cpf/`, payload).then((response) => {
          setDisplayText('Base resetada com sucesso!')
          return response
        })
      })
    } catch (error) {
      setDisplayText('Erro ao resetar base!')
      console.error('reset base error--', error)
    }
  }

  return (
    <button onClick={handleResetBase} className="reset-button">
      {displayText === 'Carregando' ? (
        <>
          {displayText}
          <svg className="loader-circular" viewBox="25 25 50 50">
            <circle
              className="circle"
              cx="50"
              cy="50"
              r="20"
              fill="none"
              strokeWidth="2"
              strokeMiterlimit="10"
              data-contrast="loader"
            />
          </svg>
        </>
      ) : (
        displayText
      )}
    </button>
  )
}

export default ResetBaseButton
